
export function BathsFilter({ value, onChange }) {

    const handleChange = (e) => {
      onChange(e.target.value);
    };

    return(
      <div className="filter">
            <div className="filter-button">
                <input type="radio" name="baths" checked={value==1} value="1" onChange={handleChange} id="1bath" />
                <label htmlFor="1bath">1</label>
            </div>
            <div className="filter-button">
                <input type="radio" name="baths" checked={value==2} value="2" onChange={handleChange} id="2bath" />
                <label htmlFor="2bath">2</label>
            </div>
            <div className="filter-button">
                <input type="radio" name="baths" checked={value==3} value="3" onChange={handleChange} id="3bath" />
                <label htmlFor="3bath">3+</label>
            </div>
        </div>
    );
}